/**
 * Currency formatting utility.
 *
 * All monetary values in the database are stored as integer cents.
 * Use formatCurrency() everywhere a dollar amount is displayed so the
 * symbol and precision are consistent and easy to change in one place.
 */

/**
 * Format a cent-denominated integer as a display currency string.
 *
 * @param {number} cents - Amount in cents, e.g. 2000 → "$20.00"
 * @returns {string}
 */
export function formatCurrency(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}
